import { useRef, useCallback, useEffect } from "react";
import { track } from "../../analytics/AnalyticsService.js";
import { AnalyticsTrackingEvent } from "../../analytics/events.js";
import { truncateQuery, getPageNameFromPath, getPageTypeFromPath } from "../tracking/ConciergeTrackingTypes.js";
const useConciergeTracking = ({
  conversationId,
  pageContext
}) => {
  const lastTrackedPageRef = useRef(null);
  const lastTrackedConversationRef = useRef(null);
  const trackConversationAccessPoint = useCallback(
    (accessPoint, query, isNewConversation) => {
      if (!conversationId) {
        return;
      }
      if (lastTrackedConversationRef.current === conversationId) {
        return;
      }
      lastTrackedConversationRef.current = conversationId;
      const pageUrl = typeof window !== "undefined" ? window.location.href : "";
      const properties = {
        accessPoint,
        conversationId,
        pageUrl,
        ...query && { query: truncateQuery(query) },
        ...isNewConversation !== void 0 && { isNewConversation },
        ...(pageContext == null ? void 0 : pageContext.stacklineSku) && { stacklineSku: pageContext.stacklineSku }
      };
      track(
        AnalyticsTrackingEvent.CONCIERGE_CONVERSATION_ACCESS_POINT,
        properties
      ).catch(() => {
      });
    },
    [conversationId, pageContext == null ? void 0 : pageContext.stacklineSku]
  );
  const trackPageContext = useCallback(() => {
    if (!conversationId) {
      return;
    }
    const pageUrl = typeof window !== "undefined" ? window.location.href : "";
    const pathname = typeof window !== "undefined" ? window.location.pathname : "/";
    const pageKey = `${conversationId}:${pageUrl}`;
    if (lastTrackedPageRef.current === pageKey) {
      return;
    }
    lastTrackedPageRef.current = pageKey;
    const pageName = getPageNameFromPath(pathname);
    const pageType = getPageTypeFromPath(pathname);
    const properties = {
      conversationId,
      pageUrl,
      pageName,
      pageType,
      ...(pageContext == null ? void 0 : pageContext.stacklineSku) && { stacklineSku: pageContext.stacklineSku }
    };
    track(
      AnalyticsTrackingEvent.CONCIERGE_PAGE_CONTEXT,
      properties
    ).catch(() => {
    });
  }, [conversationId, pageContext == null ? void 0 : pageContext.stacklineSku]);
  const trackConversationStart = useCallback(
    (accessPoint, query, isNewConversation) => {
      trackConversationAccessPoint(accessPoint, query, isNewConversation);
      trackPageContext();
    },
    [trackConversationAccessPoint, trackPageContext]
  );
  useEffect(() => {
    if (!conversationId) {
      lastTrackedPageRef.current = null;
      lastTrackedConversationRef.current = null;
      return;
    }
    const handleRouteChange = () => {
      trackPageContext();
    };
    window.addEventListener("popstate", handleRouteChange);
    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, [conversationId, trackPageContext]);
  return {
    trackConversationStart,
    trackConversationAccessPoint,
    trackPageContext
  };
};
export {
  useConciergeTracking
};
//# sourceMappingURL=useConciergeTracking.js.map
